import { FbLiveIcon as FbLiveIcon_ } from './fb-live-icon';
import { LcIcon as LcIcon_ } from './lc-icon';

export namespace Icons {
  export const LcIcon = LcIcon_;
  export const FbLiveIcon = FbLiveIcon_;
}
